<template>
  <div>
    <h2 class="text-xl font-semibold mb-2">Call Logs</h2>
    <p class="text-n-slate-11">Call logs will appear here.</p>
  </div>
</template>

<script setup>
</script>
